import { HomeSelector } from 'components/HomeSelector/HomeSelector'
import { useDataRetentionConfirmed } from 'hooks/useDataRetentionConfirmed'

export function Home() {
  const isDataRetentionConfirmed = useDataRetentionConfirmed()
  return <>{isDataRetentionConfirmed && <HomeSelector />}</>
}
